import { AuthUser } from '../types/AuthUser';
import { useUserInfo } from './useUserInfo';

export const useCurrentUser = (): AuthUser | undefined => {
  const userInfo = useUserInfo();
  return userInfo?.user;
};
